<!--
 * @Description: 我的值班 申请调班
 * @Author: PF
 * @Date: 2023-09-01 10:00:43
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:30:19
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openShenQingTiaoBan" :close-on-click-modal="false" :show-close="false"
      destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">申请调班</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openShenQingTiaoBan', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="值班人员">
              {{ row.zbryxm }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号码">
              {{ row.yddh }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="值班类别">
              {{ row.zblbmc }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="值班日期">
              {{ row.zbrq }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="值班内容名称">
              {{ row.zbnrmc }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="值班时间">
              {{ row.zbkssj }}<span v-if="row.zbkssj && row.zbjssj" class="ml5 mr5">-</span>{{ row.zbjssj }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="调换人" prop="sqthzbryid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <!-- 单选 BEGIN -->
              <el-button class="mr10" type="primary" @click="openDanTiao=true">选择</el-button>
              <el-tag class="mr10 mt10" v-if="ruleForm.sqthzbryid" closable @close="yiChu">{{ruleForm.zbryxm}}</el-tag>
              <!-- 单选 END -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否沟通" prop="sfgt" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-radio-group v-model="ruleForm.sfgt">
                <el-radio  :label="true">是</el-radio>
                <el-radio  :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="调班理由" prop="tbly" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.tbly" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openShenQingTiaoBan', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <xuanzerenyuan v-if="openDanTiao" v-model:openDanTiao="openDanTiao" :row="row" @ReturnData="ReturnData" />
</template>
<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import { closeWindow, loadSelect, actionPost } from '@/api/common.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import xuanzerenyuan from './xuanzerenyuan'

const props = defineProps({ openShenQingTiaoBan: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openShenQingTiaoBan', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({ sfgt: true })

const dhrData = ref([])
const zbzkData = ref([])

const row = ref()
const openDanTiao = ref(false)
const ReturnData = (data) => {
  ruleForm.value.sqthzbryid = data.zbryid
  ruleForm.value.sqthzbryjlid = data.id
  ruleForm.value.zbryxm = data.zbryxm
}
const yiChu = () => {
  ruleForm.value.sqthzbryid = ''
  ruleForm.value.sqthzbryjlid = ''
  ruleForm.value.zbryxm = ''
}

watch(
  () => props.openShenQingTiaoBan,
  () => {
    if (props.openShenQingTiaoBan) {
      const o = { url: '/api/v2/bangong/zhibanrenyuanrizhijilu/' + props.row.id, data: {} }
      actionPost(o).then((res) => {
        if (res.code === 200) {
          row.value = res.data
          ruleForm.value.sqzbryid = res.data.zbryid
          ruleForm.value.sqzbryjlid = res.data.id
          loadSelect({ url: '/api/v2/bangong/zhibanrenyuanjilu/jiebanren', data: dhrData, parms: { zbrwid: res.data.zbrwid, zbrq: res.data.zbrq } })
          loadSelect({ url: '/api/v2/bangong/zhibanrenyuanrizhijilu/zhibanzhuangkuang', data: zbzkData })
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  const o = { url: '/api/v2/bangong/tiaobanjilu', data: ruleForm.value }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      closeWindow('openShenQingTiaoBan', emits, true)
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
</script>
